export const styles = {
    colors: {
        blue: '#3551BE', 
        grey: '#474747',
        white: '#FFFFFF', 
        border: '#E6E6E6',
        shadow: '#01010154'
    },

    fontSize: {
        pbold: '22px',
        pextrab: '18px',
        preg: '14px',
        pblack: '32px'
    },

    fontWeight: {
        pbold: '700',
        pextrab: '800',
        preg: '400',
        pblack: '900'
    },

    hover: {
        grey: '#888686',
        blue: '#0F2B98',
        text: '#666B7D'
    },

    fontFam: "'Poppins', arial, sans-serif"

};